/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Order Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface CommonErrorInternalServerErrorError {
    'code': CommonErrorInternalServerErrorErrorCodeEnum;
    'message': string;
}

export enum CommonErrorInternalServerErrorErrorCodeEnum {
    InternalServerError = 'INTERNAL_SERVER_ERROR',
    ApiConfigurationError = 'API_CONFIGURATION_ERROR',
    AuthorizerConfigurationError = 'AUTHORIZER_CONFIGURATION_ERROR',
    AuthorizerFailure = 'AUTHORIZER_FAILURE'
}


